module.exports = __webpack_public_path__ + "img/doctor_record_table.62465c91.png";